"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserDetailsTimeOffs = void 0;
const user_details_1 = require("@app/reducer/user-details");
const store_1 = require("@app/store");
const user_details_timeoffs_1 = require("../../request/user-details-timeoffs");
const employee_card_context_1 = require("../employee-card-context");
const useEmployeeCardData_1 = require("./useEmployeeCardData");
const useUserDetailsTimeOffs = (period) => {
    const { workspace, userId } = (0, employee_card_context_1.useEmployeeCard)();
    const dispatch = (0, store_1.useRootDispatch)();
    const { data } = (0, useEmployeeCardData_1.useEmployeeCardData)({
        actionName: 'user-details-timeoffs',
        requestor: async () => await (0, user_details_timeoffs_1.requestUserDetailsTimeoffs)({
            workspaceId: workspace?.id ?? '',
            userId: userId ?? '',
            period,
        }),
        reducer: (data) => {
            dispatch((0, user_details_1.setUserTimeOffs)(data?.timeOffs));
        },
        selector: (state) => state.userDetails.timeOffs,
        listenDeps: [workspace?.id, userId, period],
    });
    return data;
};
exports.useUserDetailsTimeOffs = useUserDetailsTimeOffs;
